module.exports = __webpack_public_path__ + "static/img/pm.691e0d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/pm.png
// module id = M6VB
// module chunks = 1